import { useTranslation } from 'react-i18next'
import { Card, StepList } from '@boltenergy-be/design-system'
import { routes } from 'types/routes.ts'
import Link from 'components/link/Link.tsx'
import styles from './Complaint.module.scss'
import { trackEvent } from 'utils/tracking.ts'

const Complaint = () => {
  // i18n
  const { t } = useTranslation('support', { keyPrefix: 'complaint' })

  return (
    <>
      <p>{t(($) => $.description)}</p>

      <Card as="section" className={styles.card}>
        <Card.Title serif={false}>{t(($) => $.howItWorks.title)}</Card.Title>

        <StepList size="small">
          {(
            t(($) => $.howItWorks.steps, {
              returnObjects: true
            }) as Array<{ title: string; description: string }>
          ).map((step, index) => (
            <li key={index}>
              <div className="flex-col">
                <strong>{step.title}</strong>
                <p>{step.description}</p>
              </div>
            </li>
          ))}
        </StepList>

        <Link
          href={routes.SUPPORT_COMPLAINT_FORM}
          representation="button"
          isFullwidth
          onNavigate={() => trackEvent({ category: 'complaint', action: 'start' })}
        >
          {t(($) => $.howItWorks.action)}
        </Link>
      </Card>
    </>
  )
}

export default Complaint
